import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
const INDICATOR_INDURATION = 1000;
const TITLE_HEIGHT = 30;
import data from "./codeData.js";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
export default {
  components: {
    OverflowTooltipText
  },
  props: {
    isRequired: {
      default() {
        return true;
      }
    },
    exist: {
      default() {
        return false;
      }
    },
    value: {},
    formKey: {
      type: String,
      default() {
        return "mobile";
      }
    },
    defaultAreaCode: {
      type: String,
      default: ""
    },
    // 在组件实例创建时获取翻译，避免模块加载阶段把默认文案固定为中文。
    requiredMessage: {
      type: String,
      default() {
        return $t("shk6ya5", "手机号必填");
      }
    }
  },
  data() {
    return {
      data,
      useLazyLoad: true,
      showPopup: false,
      focus: false,
      currentIndex: 0,
      moving: false,
      currentIndicator: "",
      err_msg: "",
      isMounted: false
    };
  },
  mounted() {
    // 设置挂载标志
    this.isMounted = true;
    // 如果提供了默认区号，则设置默认值
    if (this.defaultAreaCode) {
      this.value.mobileAreaCode = this.defaultAreaCode;
    }
    // 清除初始化时的校验状态，避免页面一打开就显示校验错误
    setTimeout(() => {
      if (this.$refs.form && typeof this.$refs.form.clearValidate === "function") {
        this.$refs.form.clearValidate();
      }
    }, 100);
  },
  watch: {
    currentIndex() {
      clearTimeout(this.timer);
      this.currentIndicator = this.indexList[this.currentIndex];
      this.moving = true;
      this.timer = setTimeout(() => {
        this.moving = false;
      }, INDICATOR_INDURATION);
    },
    requirdIsTrue: {
      immediate: true,
      handler(n) {
        this.ruleValidate.mobileAreaCode[0].required = n.required || n.hasMobile;
      }
    },
    defaultAreaCode: {
      immediate: true,
      handler(newVal) {
        // 只在组件挂载后响应 defaultAreaCode 变化，避免初始化时触发校验
        if (newVal && this.isMounted) {
          this.value.mobileAreaCode = newVal;
        }
      }
    }
  },
  computed: {
    // 侧边索引直接取分组标题，和列表展示及滚动顺序保持一致。
    indexList() {
      return this.data.map(group => {
        var _group$title;
        const label = (_group$title = group.title) !== null && _group$title !== void 0 ? _group$title : "";
        return String(label).substring(0, 1);
      });
    },
    requirdIsTrue() {
      let required = this.isRequired;
      let hasMobile = this.value[this.formKey] === "" ? false : true;
      return {
        required,
        hasMobile
      };
    },
    ruleValidate() {
      const mobileRules = [{
        required: this.isRequired,
        message: this.requiredMessage,
        // message: "手机号必填",
        trigger: "blur,change"
      }, {
        pattern: /^[0-9 || *]{1,11}$/,
        message: $t("w8axw89", "请输入正确的手机号"),
        trigger: "blur,change"
      }];
      return {
        mobileAreaCode: [{
          required: true,
          // required: false,
          message: $t("aunx8j4", "区号必填"),
          trigger: "blur,change"
        }, {
          //校验写到methods里
          validator: this.validatorCode,
          trigger: "blur,change"
        }],
        [this.formKey]: mobileRules
      };
    }
  },
  methods: {
    clean() {
      this.$refs["form"].resetFields();
    },
    validate(validate) {
      return this.$refs.form.validate(validate);
    },
    handleEnter() {
      this.$emit("on-enter");
    },
    //判断当前区号在不在区号列表
    checkCode() {
      try {
        this.data.forEach(item => {
          const flag = item.items.filter(item1 => item1.id === this.value.mobileAreaCode);
          if (flag.length > 0) {
            throw new Error(flag[0].id);
          }
        });
      } catch (error) {
        return true;
      }
    },
    //校验区号
    validatorCode(rule, value, callback) {
      if (value != "" && !this.checkCode(this.data)) {
        callback(new Error($t("aupfwj4", "区号有误")));
      } else {
        callback();
      }
    },
    //国家/地区输入框失去焦点
    onBlurCode() {
      this.focus = false;
    },
    //手机号输入框失去焦点
    onBlurMobile() {
      // this.validate();
    },
    onClickOutside() {
      if (!this.focus) {
        this.showPopup = false;
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
      }
    },
    //展开国家/地区选择
    showSelectCode() {
      this.showPopup = true;
      this.listHeight = [];
      this.timer = null;
      this.scrollTimer = null;
      setTimeout(() => {
        this._calculateHeight();
      }, 20);
    },
    _calculateHeight() {
      this.listHeight = [];
      const list = this.$refs.indexGroup;
      let height = 0;
      this.listHeight.push(height);
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        height += item.clientHeight;
        this.listHeight.push(height);
      }
    },
    _onTouchStartIndex(index) {
      this.currentIndex = index;
      this.$refs.indexWrap.scrollTop = this.listHeight[index];
    },
    clickItem(item) {
      this.value.mobileAreaCode = item.id;
      this.$emit("choose", item);
      this.showPopup = false;
    },
    onListWrapScroll() {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        let scrollTop = this.$refs.indexWrap.scrollTop;
        const listHeight = this.listHeight;
        for (let i = 0; i < listHeight.length - 1; i++) {
          if (scrollTop <= listHeight[i + 1] - TITLE_HEIGHT && scrollTop >= listHeight[i]) {
            this.currentIndex = i;
            return;
          }
        }
      }, 20);
    }
  }
};